import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useExhibitionsStore = defineStore('exhibitions', {
  state,
  getters,
  actions
})

export default useExhibitionsStore
